import extractBackgroundOverlays from '@activebrands/core-web/libs/storyblok/utils/extract-background-overlays';
import transformFlexibleBackgrounds from '@activebrands/core-web/libs/storyblok/utils/transform-flexible-backgrounds';
import transformHeading from '@activebrands/core-web/libs/storyblok/utils/transform-heading';
import transformParagraph from '@activebrands/core-web/libs/storyblok/utils/transform-paragraph';
import transformPreviewEditable from '@activebrands/core-web/libs/storyblok/utils/transform-preview-editable';
import { FeatureItem } from '@activebrands/core-web/types/feature-item';

const transformFeatureItemData = (item: any = {}): FeatureItem => {
    const { _editable, backgroundMobile, backgroundDesktop, heading, paragraph } = item;

    const backgroundOverlay = extractBackgroundOverlays([backgroundMobile[0], null, null, null, backgroundDesktop[0]]);

    const transformedBackgrounds = transformFlexibleBackgrounds(
        [backgroundMobile[0], null, null, null, backgroundDesktop[0]],
        1
    );

    return {
        background: transformedBackgrounds,
        backgroundOverlay,
        heading: transformHeading({ heading, defaultType: 'h3' }),
        id: item?._uid,
        paragraph: transformParagraph({ paragraph }),
        sbEditable: transformPreviewEditable(_editable),
        type: 'feature',
    };
};

export default transformFeatureItemData;
